import { useBloomreachPageModels } from "./use-bloomreach-page-models.js";
import { useBrPageContext } from "../../context/context/context.js";
function useBloomreachPageRoutes() {
  const page = useBrPageContext();
  const pageModels = useBloomreachPageModels();
  const pageRoutes = pageModels?.routes;
  if (!pageRoutes) {
    return { routes: {} };
  }
  let cleanedRoutes = pageRoutes;
  if (page.isPreview()) {
    cleanedRoutes = Object.keys(pageRoutes).reduce((acc, key) => {
      const route = pageRoutes[key].split("?")[0];
      return { ...acc, [key]: route ?? "" };
    }, {});
  }
  return { routes: cleanedRoutes };
}
export {
  useBloomreachPageRoutes
};
//# sourceMappingURL=use-bloomreach-page-routes.js.map
